import { MenuBaseProps } from "./Menu";

export const MenuList: MenuBaseProps[] = [
  {
    icon: "svgModeration",
    title: "Moderation",
    path: "/moderation",
  },
  {
    icon: "svgTemplates",
    title: "Templates",
    path: "/templates",
  },
  {
    icon: "historyMenu",
    title: "History",
    path: "/history",
  },
  // {
  //   icon: 'svgDraft',
  //   title: 'Deleted',
  //   path: '/deleted'
  // },
  // {
  //   icon: 'svgGroup',
  //   title: 'History',
  //   path: '/history'
  // },
];
